// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "style/batamp/" + chunkId + ".bundle.css"; };